import { useRef, useEffect } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useRequest = (requestFn: () => Promise<void>, deps: any[] = []) => {
  const hasRunRef = useRef(new Map<string, boolean>());

  const key = JSON.stringify(deps);

  useEffect(() => {
    if (!hasRunRef.current.has(key)) {
      hasRunRef.current.set(key, true);
      requestFn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
};

export default useRequest;
